import React, { Component } from 'react';
import FX from './functions/functions';
import SweetAlert from 'sweetalert2-react';
import './css/PackingStation.css';

class PackingStation extends Component {
  constructor(props) {
    super(props);
    this.state = JSON.parse(JSON.stringify(this.defaultState));
        console.log(this.props.root.state.panelData);
        console.log(this.props.root.state.panelData.packingStation.dispatch_id);
    if(this.props.root.state.panelData.packingStation && this.props.root.state.panelData.packingStation.dispatch_id){
        console.log(this.props.root.state.panelData.packingStation.dispatch_id);
        this.searchDispatch(this.props.root.state.panelData.packingStation.dispatch_id);

      var panelData = this.props.root.state.panelData;
      panelData.packingStation = {};
      this.props.root.setState({panelData:panelData});
    }
  }
  defaultState = {
      authedBy: false,
      boxes: [{weight:0}],
      boxSaved : false,
      courier: false,
      overridden: false,
      packable : false,
      packageSize: false,
      packaging: [],
      packagingSaved: false,
      packed: {contents : []},
      packStart: false,
      selectPackages: true,
      tracking_code: false,
      consignments: [{courier: false, packageSize: false, boxes:[], service:false}],
      current_con: 0,
      service : false
  };
  componentWillUpdate(nextProps, nextState){
    if(nextState.packable && (nextState.packable.dispatch_items.length === 0)){
      //alert('Done');
    }
  }
  componentDidMount(){
    this.props.root.current = this;
    if(this.props.root.state.preLoad){
      this.searchDispatch(this.props.root.state.preLoad);
      this.props.root.setState({preLoad : undefined  });
    }
    console.log(this.focus);
    if(this.focus && document.getElementById(this.focus)){
      document.getElementById(this.focus).focus();
      document.getElementById(this.focus).select();
      this.focus = '';
    }
  }
  refresh(){
      var panelData = this.props.root.state.panelData;
      panelData.packingStation = {};
      this.props.root.setState({panelData:panelData});
      this.setState(JSON.parse(JSON.stringify(this.defaultState)));
  }
  componentWillUnmount(){
    this.props.root.current = undefined;
  }


  componentDidUpdate(){
    console.log(this.focus);
    if(this.focus && document.getElementById(this.focus) && document.getElementById(this.focus) !== document.activeElement ){
      document.getElementById(this.focus).focus();
      document.getElementById(this.focus).select();
      this.focus = '';
    }
    else {
      this.focus = '';
    }
  }
  focus = '';
  searchDispatch = (tgt) => {
      if(typeof tgt !== "number"){
        tgt = parseInt(document.getElementById('searchPhrase').value, 10)
      }
      FX.load(this.props.root,'packingStation' , (res, i) => {
          this.setState({packable:res[0],
          packStart:FX.dateFormat(new Date(),'{Y}-{m2}-{d2} {H}:{i}:{s}')});
      }, {method:'POST',data:{searchPhrase : tgt}});
  }
  authOver = () => {
    if(!document.getElementById('authCode')){
      return false;
    }
    FX.load(this.props.root,'packingStationAuth' , (res, i) => {
          console.log(res);
          console.log(res.success);
          if(res.success){
             this.setState({overridden:false, authedBy: document.getElementById("authCode").value});
          }
    }, {method:'POST',data:{ authCode: document.getElementById('authCode').value}});
  }
  packItem = () => {
    console.log(document.querySelector('#itemSelectField').value);
    if(!document.querySelector('#itemSelectField').value){
        alert("Please enter a Sku or a Barcode.");
       return false;
    }
    var shout =  true;
    this.state.packable.dispatch_items.some((item,i) => {
      console.log(item);
      if(
        item.product.sku.toString().toLowerCase() === document.querySelector('#itemSelectField').value.toLowerCase() ||
        ((item.product.barcode !== null && item.product.barcode !== undefined) && item.product.barcode.toString().toLowerCase() === document.querySelector('#itemSelectField').value.toLowerCase())
      ){
        window.qonfirm = i;
         this.confirmQ();
         shout = false;
        return true;
      }
    });
    if(shout){

          document.getElementById('break').play();
        alert('DO NOT PACK');
      document.querySelector('#itemSelectField').value = '';
      document.querySelector('#quantity').value = 1;
      document.getElementById("itemSelectField").focus();
    }
  }
  confirmPacked = (force) => {
    if(this.state.packable.dispatch_items.length ){
      alert('Still stuff to pack!');
    }
    else{
      if(this.boxesReady() && this.serviceConfirmed() && this.confirm('Mark this order as Packed?')){
          console.log(window.packed);
          this.sender();
          //window.location = ( '/v1/packed/' + parseInt(<?php echo $_GET['id']; ?>));
      }
    }
  }
  showModal = () =>{
     //document.getElementById('modal').style.display = 'block';
     //this.setState({modal:true});
     this.setState({addWeight:true});
     //document.getElementsByClassName('box_weight')[document.getElementsByClassName('box_weight').length-1].focus();
     //document.getElementsByClassName('box_weight')[document.getElementsByClassName('box_weight').length-1].setSelectionRange(0, document.getElementsByClassName('box_weight')[document.getElementsByClassName('box_weight').length-1].value.length);

  }
  showModalService = () =>{
     this.hideModal();
     document.getElementById('modal').style.display = 'block';
     document.getElementById('selectService').style.display = 'block';
     document.getElementById('service').focus();
  }
  setService = (ps) =>{
    console.log(ps);

    var consignments = this.state.consignments;
    consignments[this.state.current_con].service = ps;
    this.setState({ /* packageSize:ps, */ consignments:consignments});
  }
  setPackageSize = (ps) =>{
    var consignments = this.state.consignments;
    consignments[this.state.current_con].packageSize = ps;
    this.setState({ /* packageSize:ps, */ consignments:consignments});
  }
  hideModal = () =>{
     document.getElementById('modal').style.display = 'none';
     document.getElementById('weightBox').style.display = 'none';
     document.getElementById('selectService').style.display = 'none';
  }
  enterBoxWeight = () =>{
     this.showModal();
  }
  enterBoxWeight = () => {
     this.showModal();
  }
  boxesReady = () => {
    var ready = true;
    var iz = 0;
    for (var ink = 0; ink < this.state.boxes.length; ink++){
      iz += parseFloat(this.state.boxes[ink].weight);
    }
    console.log(ink);
    if(iz == 0){
      ready = false;
      this.enterBoxWeight();
    }
    console.log(ready);
    return ready;
  }
  serviceConfirmed = () => {
    if(this.state.serviceSelected){
      return true;
    }
    else {
      this.showModalService();
    }
  }
  confirmQ = () => {
    console.log(this.state.packable.dispatch_items[window.qonfirm]);
    //document.querySelector('#quanity-query').classList.remove("show");

    var rQ = parseInt(document.querySelector('#quantity').value);

    var packable = this.state.packable;

    if(packable.dispatch_items[window.qonfirm].quantity - rQ === 0){
      this.packed_add(packable.dispatch_items[window.qonfirm]);
      packable.dispatch_items.splice(window.qonfirm,1);
      document.querySelector('#itemSelectField').value = '';
      document.getElementById('dongk').play();
      document.querySelector('#quantity').value = 1;
      document.getElementById("itemSelectField").focus();
      //document.querySelector('#qq').value = '';
    }
    else if(packable.dispatch_items[window.qonfirm].quantity - rQ > 0){
      var x = Object.assign({}, packable.dispatch_items[window.qonfirm]);
      x.quantity = parseInt(rQ);
      this.packed_add(x);
      packable.dispatch_items[window.qonfirm].quantity -= rQ

      document.getElementById('beep').play();

      document.querySelector('#itemSelectField').value = '';
      document.getElementById("itemSelectField").focus();
      document.querySelector('#quantity').value = 1;
      //document.querySelector('#qq').value = '';
    }
    else {
          document.getElementById('break').play();
      alert('You\'ve selected too many Products!');
      document.querySelector('#itemSelectField').value = '';
      document.querySelector('#quantity').value = 1;
      document.getElementById("itemSelectField").focus();
    }

    if(packable.dispatch_items.length == 0){
      this.setState({packable:packable}, this.confirmPacked);
      this.focus = 'i_0';
    }
    this.setState({packable:packable});
  }
  packed_add = (a) => {
    var push = true;
    console.log(a.product);
    var packed = this.state.packed;
    packed.contents.some((item,i) => {
      if(
        item.product === a.product
      ){
        item.quantity += parseInt(a.quantity);
        push = false;
        return true;
      }
    });
    if(push){
      packed.contents.push(a);
      this.setState({packed:packed});
    }
  }
  updatePackages = (tgt , evt) => {
    //console.log();
    var boxes = this.state.boxes;
    boxes[parseInt(evt.target.id.replace('i_', ''))][tgt] = evt.target.value;
    //boxes.push({weight:0});
    this.setState({boxes:boxes});
  }
  addBox = () => {
    //storeWeights();
    var boxes = this.state.boxes;
    for( var i = 0; i < boxes.length; i++ ){
        console.log(boxes[i].weight);
        console.log(isNaN(boxes[i].weight));
       if(!isNaN(boxes[i].weight)){
         boxes[i].weight = parseFloat(boxes[i].weight);
       }
    }
    boxes.push({weight:0});
    this.focus = 'i_' + (boxes.length -1);
    this.setState({boxes:boxes});
  }
  removeBox = (i) => {
  //storeWeights();
    var boxes = this.state.boxes;
    boxes.splice(i, 1);
    this.setState({boxes:boxes});
  }
  saveBoxes = (undo) => {
  //storeWeights();
    var boxes = this.state.boxes;
    var passCheck = !!this.state.boxes.length;
    var heavy = false;

    for(var i = 0; i < boxes.length; i++){
      console.log(boxes[i].weight);
      console.log(isNaN(boxes[i].weight));
      if(isNaN(boxes[i].weight) || boxes[i].weight == 0){
        passCheck = false;
      }
      else if (boxes[i].weight > 30) {
        heavy = true;
        boxes[i].weight = parseFloat(boxes[i].weight);
      }
      else {
        boxes[i].weight = parseFloat(boxes[i].weight);
      }
    }
    if(passCheck){
        if(!undo || !heavy || (heavy && window.confirm('Some of the boxes are very heavy.\nPlease confirm weights in kilogrammes'))){
            this.setState({boxSaved:undo});

        }
    }
    else {
      alert('Please check all entered weights in kilogrammes');
    }
  }
  savePackaging = (undo) => {
  //storeWeights();
     if(this.state.packaging && this.state.packaging.length){
       this.setState({packagingSaved:undo});
     }
     else {
       this.props.root.setState({show:true});
     }
  }
  setCourier = (c) => {
    var consignments = this.state.consignments;
    this.state.consignments[this.state.current_con].courier = c;
    this.setState({courier:c, consignments:consignments});
  }
  addPackaging = (p) => {
    var packaging = this.state.packaging;
    var del = -1;
    if(p.id == 1 && packaging.length && window.confirm('Remove Added Packaging?')){
       packaging = [];
      packaging.push(p);
    }
    else if (p.id == 1 && packaging.length == 0) {
      packaging.push(p);
    }
    else if (p.id != 1) {
        packaging.some((pack, i) => {
           console.log(pack);
           if(1 === parseInt(pack.id,10)){
             del = i;
             return true;
           }
           return false;
        });
        if (del > -1){
          packaging.splice(del,1);
        }
        packaging.push(p);
    }
    this.setState({packaging:packaging});
  }
  removePackaging = (i) => {
    var packaging = this.state.packaging;
    packaging.splice(i,1);
    this.setState({packaging:packaging});
  }
   perCep = (e) =>{
    console.log(e);
    if((e.key === 'Enter' || e.keyCode === 13) && (e.target.id ==='itemSelectField' || e.target.id ==='quantity')){
      this.packItem();
    }
    //if((e.key === 'Enter' || e.keyCode === 13) && e.target.id ==='qq'){
    //  confirmQ();
    //}
    if((e.key === 'Enter' || e.keyCode === 13) && (e.target.id ==='searchPhrase')){
      this.searchDispatch();
    }
    if((e.key === 'Enter' || e.keyCode === 13) && (e.target.id ==='authCode')){
      this.authOver();
    }
    if(e.key === '+' && (e.target.classList.contains('box_weight'))){
      //redrawList();
      //enterBoxWeight();
      this.addBox();
    }
  }
  selectPackages = () => {
    if(!this.state.selectPackages){
      this.setState({ selectPackages: true });
    }
    else {
      if(this.state.consignments[this.state.current_con].boxes.length){
        this.setState({ selectPackages: !this.state.selectPackages });
      }
      else if(!this.state.consignments[this.state.current_con].boxes.length && this.state.consignments.length === 1) {
        this.selectAllBoxes();
      }
      else {
        alert("Please select packages to include.");
      }
    }
    /*if(this.state.boxes.length >= (this.state.consignments.length + 1)){
      console.log(this.state);
      this.setState({ selectPackages: true });
    }
    else {
      alert("You can't have more consignments than packages");
    }*/
  }
  setConsignment = (tgt) => {
     this.setState({current_con: tgt})
  }
  addConsignment = () => {
    var consignments = this.state.consignments;
    /*for( var i = 0; i < consignments.length; i++ ){
         if(!consignments[i].service.id){
            alert('Please select a Service - ' + i);
            return false;
         }
    }*/
    var tracking_code;
    if(document.getElementById('tracking_code')){
      tracking_code = document.getElementById('tracking_code').value;
    }
    if(parseInt(this.state.consignments[this.state.current_con].service.pre_tracked,10) && (tracking_code.trim() == '' || tracking_code.length < 6)){
      alert('Please Scan Tracking Code for this Service');
      return false;
    }
    else{
      this.state.consignments[this.state.current_con].tracking_code = tracking_code;
    }

    if(this.state.boxes.length >= (this.state.consignments.length + 1)){
      console.log(this.state);
      this.setState({ selectPackages: true });
    }
    else {
      alert("You can't have more consignments than packages");
      return false;
    }
    console.log(this.state);
    var c = {courier: false,packageSize: false,boxes:[],service:false,tracking_code:''}
    consignments.push(c);
    this.setState({consignments: consignments, selectPackages: true, current_con: consignments.length -1});



  }
  removeConsignment = (tgt) => {
    var boxes = this.state.boxes;
    var consignments = this.state.consignments;
    consignments.splice(tgt, 1);

    for( var j = 0; j < boxes.length; j++ ){
          if(boxes[j].consignment === tgt){
              boxes[j].consignment = undefined
          }
          else if(boxes[j].consignment > tgt){
              boxes[j].consignment--
          }
    }
    var selpax = false;
    if(window.confirm("Do you want to create a new consignment?")){
      selpax = true;
    }
    this.setState({consignments: consignments, selectPackages: selpax, current_con: consignments.length -1});
  }
  confirm = () => {
    var tracking_code;
    if(document.getElementById('tracking_code')){
      tracking_code = document.getElementById('tracking_code').value;
    }
    if(parseInt(this.state.consignments[this.state.current_con].service.pre_tracked) && (tracking_code.trim() == '' ||tracking_code.length < 6)){
      alert('Please Scan Tracking Code for this Service');
      return false;
    }
    else {
      this.state.consignments[this.state.current_con].tracking_code = tracking_code;
    }
    var consignments = this.state.consignments;
    var boxes = this.state.boxes;
    var cons = [];
    for( var i = 0; i < consignments.length; i++ ){
         if(!consignments[i].service.id){
            alert('Please select a Service - ' + i);
            return false;
         }
         var con = {
            service:consignments[i].service.id,
            tracking_code:consignments[i].tracking_code,
            boxes: []
         }
         for( var j = 0; j < boxes.length; j++ ){
              if(boxes[j].consignment === i){
                  con.boxes.push(boxes[j]);
              }
         }
         cons.push(con);
    }


    var pass = true;
    for( var i = 0; i < boxes.length; i++ ){
        if(boxes[i].consignment === undefined){
          pass = false;
        }
    }
    if(!pass){
      alert('All packages need to be assigned to a consignment');
      this.setState({selectPackages: true});
      return false;
    }
    var packagingX = [];
    this.state.packaging.forEach((p)=>{
      var updated = false;
      packagingX.forEach(px => {
        if(px.packaging_id == p.id){
          px.quantity++;
          updated = true;
        }
      });
      if(!updated){
        packagingX.push({packaging_id: p.id, quantity: 1});
      }
      console.log(packagingX);
    });
    this.forceUpdate();
    var tracking_code;


    var v = {
      dispatch_id:this.state.packable.id,
      tracking_code: tracking_code,
      service:this.state.service.id,
      packaging:packagingX,
      boxes:this.state.boxes,
      packer:this.props.root.state.user.id,
      packStart:this.state.packStart,
      consignments:cons,
      packEnd:FX.dateFormat(new Date(),'{Y}-{m2}-{d2} {H}:{i}:{s}'),
      authedBy: this.state.authedBy
    }
    // Pre-open the label window NOW, synchronously inside the click handler, so
    // it counts as a user-initiated popup. If we instead called window.open()
    // later inside the async packingStationComplete callback, the browser would
    // treat it as a non-user-gesture popup and silently BLOCK it — which means
    // generateLabel.php is never loaded, the courier label is never requested,
    // and nothing prints. We redirect this pre-opened window to the label URL
    // once the pack is confirmed.
    var labelWin = window.open('about:blank', 'pack_label');

    FX.load(this.props.root,'packingStationComplete' , (res, i) => {
      if(res && res.success){
        // generateLabel.php (server-side) creates the courier label and
        // 302-redirects the browser to the local print agent
        // (http://127.0.0.1:8080/<REF>.pdf), which prints it. That final hop is
        // a top-level navigation, so it is NOT blocked under HTTPS. (The old
        // window.print_server_loaded === 'active' gate was removed because the
        // flag is set by an XHR health-check to the agent, which HTTPS blocks.)
        var url = this.props.root.paths.utilityHost + '/consignment/generateLabel.php?con_id=' + res.target;
        if(labelWin){
          labelWin.location = url;           // redirect the pre-opened window
        } else {
          var w = window.open(url);          // fallback if pre-open was blocked
          if(!w){ alert('The label window was blocked by the browser. Please allow pop-ups for this site, then re-pack or use Get Label.'); }
        }
        this.reset();
      } else {
        // Pack did not confirm server-side — no consignment/label was created.
        if(labelWin){ try { labelWin.close(); } catch(e){} }
        alert('Could not complete the pack' + ((res && res.error_text) ? (': ' + res.error_text) : '') + '. No label was created.');
      }
    }, {method:'POST',data: v});

  }
  selItem = (item) => {
    if(window.confirm('Please double check "' + item.product.sku + '" is the correct product')){
      document.getElementById("itemSelectField").value = item.product.sku;
      if(item.product.barcode){
        item.override = true;
        this.setState({overridden:true});
      }
      if(document.getElementById("quantity")){
        document.getElementById("quantity").focus();
        document.getElementById("quantity").setSelectionRange(0, document.getElementById("quantity").value.length);
      }
    }
  }
  xxauthOver = () => {
    console.log(document.getElementById("authCode").value);
    if(document.getElementById("authCode").value == '90911'){
        this.setState({overridden:false, authedBy: document.getElementById("authCode").value});
    }
    document.getElementById("authCode").value ='';
  }
  blanker = () => {
    this.setState({packable:false});
  }
  reset = () => {
    console.log(this.defaultState);
    var nState = JSON.parse(JSON.stringify(this.defaultState));
    this.setState(nState);
    console.log(this.state);
  }
  toggleBox = (tgt_box, tgt_consignment) => {
    var boxes = this.state.boxes;
    var consignments = this.state.consignments;
    if(boxes[tgt_box].consignment == tgt_consignment){
      boxes[tgt_box].consignment = undefined;
    }
    else{
      boxes[tgt_box].consignment = tgt_consignment;
    }
    for( var i = 0; i < consignments.length; i++ ){
         consignments[i].boxes = [];
         for( var j = 0; j < boxes.length; j++ ){
              if(boxes[j].consignment === i){
                  consignments[i].boxes.push(boxes[j]);
              }
         }
    }
    this.setState({boxes: boxes, consignments: consignments});
  }
  selectAllBoxes = () => {
    var boxes = this.state.boxes;
    var consignments = this.state.consignments;
    for(var i = 0; i < boxes.length; i++){
      boxes[i].consignment = 0;
    }
    for( var i = 0; i < consignments.length; i++ ){
         consignments[i].boxes = [];
         for( var j = 0; j < boxes.length; j++ ){
              if(boxes[j].consignment === i){
                  consignments[i].boxes.push(boxes[j]);
              }
         }
    }
    this.setState({boxes: boxes, consignments: consignments});
  }
  render() {
      var packable;
      var address_tag;
      var productList;
      var packedList;
        console.log(this);
       packedList = this.state.packed.contents.map(( ditz ) => {
        var className = "packedItem";
          this.state.packable.dispatch_items.some(di => {
            if(ditz.product_id == di.product_id){
              className += ' more '
              return true;
            }
          });
          if (ditz.override && this.state.overridden){
            className += ' override'
          }
          else if (ditz.override){
            className += ' authed'
          }
           return (
            <div className={className} key={ditz.id}>
                <span className="name">{ditz.product.name}</span>
                <span className="sku">{ditz.product.sku}</span>
                <span className="bc">{ditz.product.barcode}</span>
                <span className="q">{ditz.quantity}</span>
            </div>
           );
      });
      if(this.state.packable){
        address_tag = (<div className="address_tag">
                      <div className="reference">{this.state.packable.reference}</div>
                      <div><span className="company">{this.state.packable.delivery_address.company}</span>
                      <span className="forename">{this.state.packable.delivery_address.forename}</span>
                      <span className="surname">{this.state.packable.delivery_address.surname}</span></div>
                      <div className="postcode">{this.state.packable.delivery_address.postcode}</div>
                      <div className="country_code">{this.state.packable.delivery_address.country_code}</div>
                   </div>)
      }
      if(this.state.packable && parseInt(this.state.packable.hold)){
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <h3 onClick={this.blanker}>This dispatch has been held.</h3>
            <div onClick={this.blanker}>Back</div>
          </div>
        )
      }
      else if(this.state.packable && this.state.packable.dispatch_items.length > 0){
      if(this.state.packable.dispatch_status >= 30){
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <h3 onClick={this.blanker}>This dispatch has been packed.</h3>
            <div onClick={this.blanker}>Back</div>
          </div>
        )
      }
      this.focus = 'itemSelectField';
        packable = (<div className="address_tag">
                      <div className="reference">{this.state.packable.reference}</div>
                      <div><span className="company">{this.state.packable.delivery_address.company}</span>
                      <span className="forename">{this.state.packable.delivery_address.forename}</span>
                      <span className="surname">{this.state.packable.delivery_address.surname}</span></div>
                      <div className="postcode">{this.state.packable.delivery_address.postcode}</div>
                      <div className="country_code">{this.state.packable.delivery_address.country_code}</div>
                   </div>);
         productList = this.state.packable.dispatch_items.map(( ditz ) => {
             return (
              <div className="unpackedItem"  onClick={this.selItem.bind(this,ditz)} key={ditz.id}>
              <div className="name">{ditz.product.name}</div>
              <div className="sku">{ditz.product.sku}</div>
              <div className="barcode">{ditz.product.barcode}</div>
              <div className="quantity">{ditz.quantity}</div>
              </div>
             );
        });

        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            {packable}
            <div>
            <h2>Unpacked</h2>
            <div className="productList">
            {productList}
            </div>
            </div>
            <div>
            </div>
            <div className="btmBar">
                <input onKeyPress={this.perCep} id="itemSelectField"/>
                <input onKeyPress={this.perCep} defaultValue="1" id="quantity"/>
                <button className="button" onClick={this.packItem}>Pack Item</button>
            </div>
            <div className="rightBar">
            <h2>Packed</h2>
            {packedList}
            </div>
          </div>
        );
      }
      else if (this.state.packable && this.state.overridden){
      var packedList;
        console.log(this);
        this.focus = "authCode";
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>Authorisation required</h1>
            <input onKeyPress={this.perCep} type="password" style={{width:'40%',padding:'10px'}} id="authCode"/>
            <button className="button" onClick={this.authOver}>Authorise</button>
            <div className="rightBar">
            <h2>Packed</h2>
            {packedList}
            </div>
          </div>
        );



        this.setState({overridden:false});
      }
      else if (this.state.packable && !this.state.boxSaved){
         var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <input style={{padding:10}} id={'i_' + i} value={box.weight} onChange={this.updatePackages.bind(this,'weight')}/>&nbsp;kg
              &nbsp;<input style={{padding:10, width: 60}} id={'i_' + i} value={box.dim_1} placeholder={'Height'} onChange={this.updatePackages.bind(this,'dim_1')}/>cm&nbsp;
              &nbsp;<input style={{padding:10, width: 60}} id={'i_' + i} value={box.dim_2} placeholder={'Width'} onChange={this.updatePackages.bind(this,'dim_2')}/>cm&nbsp;
              &nbsp;<input style={{padding:10, width: 60}} id={'i_' + i} value={box.dim_3} placeholder={'Length'} onChange={this.updatePackages.bind(this,'dim_3')}/>cm&nbsp;
              <button style={{padding:10}} onClick={this.removeBox.bind(this,i)}>x</button>
              </div>
             );
        });

        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>
            <h3>Enter weight</h3>
            <div>{weightList}</div>
            <button style={{padding:10}} onClick={this.addBox}>+</button>
            </div>
            <div className="rightBar">
                <h2>Packed</h2>
                {packedList}
                <button className="next_btn" onClick={this.saveBoxes.bind(this,true)}>Finished Adding Packages</button>
            </div>
          </div>
        );
      }
      else if (this.state.packable && this.state.boxSaved && this.state.packagingSaved === false){
        var c_pkgng = this.props.root.state.utilities.packaging.map((p) => {
          console.log(p);
          console.log(this.state.packable.customer_id);
          if (p.customer_id == this.state.packable.customer_id) {
          return (<div className="packScreenOpt" onClick={this.addPackaging.bind(this,p)}>
             {p.name}
          </div>)
         }
        });
        c_pkgng = (<div className="c_pkgng">{c_pkgng}</div>)
        var pkgng = this.props.root.state.utilities.packaging.map((p) => {
          console.log(p);
          console.log(this.state.packable.customer_id);
          if (!p.customer_id && parseInt(p.id,10) !== 1) {
          return (<div className="packScreenOpt" onClick={this.addPackaging.bind(this,p)}>
             {p.name}
          </div>)
         }
        });
        pkgng = (<div className="pkgng">{pkgng}</div>)
        var n_pkgng = this.props.root.state.utilities.packaging.map((p) => {
          console.log(p);
          console.log(this.state.packable.customer_id);
          if (parseInt(p.id,10) === 1) {
          return (<div className="packScreenOpt" onClick={this.addPackaging.bind(this,p)}>
             {p.name}
          </div>)
         }
        });
        n_pkgng = (<div className="n_pkgng">{n_pkgng}</div>)
        var selPack = this.state.packaging.map((p,i) => {
              return (<div className="packageItem removable">
                 {p.name} <i className="material-icons" onClick={this.removePackaging.bind(this,i)}>close</i>
              </div>)
        });
        var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>Packaging</div>
            <div className="packaging_list">
            {c_pkgng}
            {pkgng}
            {n_pkgng}
            {address_tag}
            </div>
            <div className="rightBar">
            <h2>Packed</h2>
            {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              <button className="next_btn" onClick={this.savePackaging.bind(this,true)}>Save Packaging</button>
            </div>
            <div className="btmBar">
              <SweetAlert
                    show={this.props.root.state.show}
                    title="Please Select Packaging"
                    text={"If no packaging was required, please select \"No Packaging\""}
                    onConfirm={() => this.props.root.setState({ show: false })}
                  />
              <div className="back_btn" onClick={this.saveBoxes.bind(this,false)}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );
      }
      else if (this.state.packable && this.state.boxSaved && this.state.packagingSaved && this.state.selectPackages ){

         var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
        var selPack = this.state.packaging.map((p,i) => {
          return (<div className="packageItem">
             {p.name}
          </div>)
        });
        var allServiced = true;
        var consList = this.state.consignments.map(( con, i ) => {
             if(!con.service){
               allServiced = false;
             }
             var currentClass = '';
             if( i === this.state.current_con ){
               currentClass = " current";
             }
             return (
              <div className={"cons_item " + currentClass} key={i} onClick={this.setConsignment.bind(this,i)}>
                  <i className="material-icons" onClick={this.removeConsignment.bind(this,i)}>close</i>
                  <div style={{padding:10}}>{i + 1} - {con.service.name}</div>
                  <div style={{padding:10}}>{con.packageSize.name}</div>
              </div>
             );
        });
         var allAssigned = allServiced;
         var boxList = this.state.boxes.map(( box, i ) => {
              var className = '';
              if(box.consignment !== undefined && box.consignment == this.state.current_con){
                className = 'current';
              }
              else if(box.consignment !== undefined){
                className = 'assigned';
              }
              else {
                allAssigned = false;
              }
             return (
              <div className={"selectBox " + className} key={i} onClick={this.toggleBox.bind(this,i,this.state.current_con)}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });

        var completeDispatch;
        if(!allAssigned){
            completeDispatch = (<button className="completeDispatch" onClick={this.selectPackages}>Select Packages</button>);
        }
        else {
            completeDispatch = (<div><button className="act_btn" onClick={this.selectPackages}>Select Packages</button>
                                <button className="completeDispatch" onClick={this.confirm}>Complete Dispatch</button></div>);
        }
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>
            <div>Select Packages</div>
            <h2>
              {this.state.packable.post_service.name}
              <div className="boxList">
                  {boxList}
              </div>
            </h2>
            {address_tag}
            </div>


            <div className="rightBar">
            <h2>Packed</h2>
              {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              {completeDispatch}
              {tracking_code}
              <h2>Consignments</h2>
              <div>
                {consList}
              </div>
            </div>
            <div className="btmBar">
              <div className="back_btn" onClick={this.savePackaging.bind(this,false)}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );
      }
      else if (this.state.packable && this.state.boxSaved && this.state.packagingSaved && this.state.consignments[this.state.current_con].courier === false){
        var couriers = [{id: 0, name: "VDepot"}].concat(this.props.root.state.utilities.couriers);
        var _co = [];
         var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
        var consList = this.state.consignments.map(( con, i ) => {
             var currentClass = '';
             if( i === this.state.current_con ){
               currentClass = " current";
             }
             return (
              <div className={"cons_item " + currentClass} key={i} onClick={this.setConsignment.bind(this,i)}>
                  <i className="material-icons" onClick={this.removeConsignment.bind(this,i)}>close</i>
                  <div style={{padding:10}}>{i + 1} - {con.service.name}</div>
                  <div style={{padding:10}}>{con.packageSize.name}</div>
              </div>
             );
        });
        var selPack = this.state.packaging.map((p,i) => {
          return (<div className="packageItem">
             {p.name}
          </div>)
        });
        couriers.forEach((c, i) => {
          console.log(c);
          c.post_services = [];
          this.props.root.state.utilities.post_services.forEach((ps) => {
            if(ps.courier_id == c.id){
              c.post_services.push(ps);
            }
          });
          if(c.post_services.length > 0){
            _co.push(c);
          }
        });
        var courierSelect = _co.map(c => {
          if(c.id == this.state.packable.post_service.courier_id){
            return (<div className="packScreenOpt recommended" onClick={this.setCourier.bind(this,c)}>
             {c.name}
            </div>)
          }
          return (<div className="packScreenOpt" onClick={this.setCourier.bind(this,c)}>
             {c.name}
          </div>)
        });
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>Courier</div>
            <div>
            <h2>
            {this.state.packable.post_service.name}
            </h2>
            <div className="serviceSelect">
            {courierSelect}
            </div>
            {address_tag}
            </div>
            <div className="rightBar">
            <h2>Packed</h2>
            {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              <h2>Consignments</h2>
              <div>
                {consList}
              </div>
            </div>
            <div className="btmBar">
              <div className="back_btn" onClick={this.selectPackages}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );
      }
      else if (this.state.packable && this.state.boxSaved && this.state.consignments[this.state.current_con].courier && this.state.consignments[this.state.current_con].packageSize === false){
        var package_sizes = [];
        var totalWeight = 0;
         var weightList = this.state.boxes.map(( box, i ) => {
            if(box.consignment !== undefined &&  box.consignment == this.state.current_con){
              totalWeight += (box.weight * 1000);
            }
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
        var consList = this.state.consignments.map(( con, i ) => {
             var currentClass = '';
             if( i === this.state.current_con ){
               currentClass = " current";
             }
             return (
              <div className={"cons_item " + currentClass} key={i} onClick={this.setConsignment.bind(this,i)}>
                  <i className="material-icons" onClick={this.removeConsignment.bind(this,i)}>close</i>
                  <div style={{padding:10}}>{i + 1} - {con.service.name}</div>
                  <div style={{padding:10}}>{con.packageSize.name}</div>
              </div>
             );
        });
        var selPack = this.state.packaging.map((p,i) => {
          return (<div className="packageItem" >
             {p.name}
          </div>)
        });
        this.props.root.state.utilities.package_sizes.forEach((ps) => {
          try{
            var dest_list = JSON.parse(ps.destination_list);
          }
          catch(e){
            var dest_list = null;
          }


          if((dest_list == null) || (dest_list.accept && dest_list.accept.indexOf(this.state.packable.delivery_address.country_code) !== -1) || (dest_list.deny && dest_list.deny.indexOf(this.state.packable.delivery_address.country_code) == -1)){
            if(ps.courier_id == this.state.courier.id && ps.weight_min < totalWeight && ps.weight_max >= totalWeight){
              package_sizes.push(ps);
            }
          }
        });
        var sizeSelect = package_sizes.map(ps => {
          console.log(ps);
          return (<div className="packScreenOpt" onClick={this.setPackageSize.bind(this,ps)}>
             {ps.name}
          </div>)
        });
        if(!package_sizes.length){
          sizeSelect = (<div className="packScreenOpt" onClick={this.setPackageSize.bind(this,0)}>
             All
          </div>)
        }
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>
            <div>Package Size</div>
            <h2>
            {this.state.packable.post_service.name}
            </h2>
            {sizeSelect}
            {address_tag}
            </div>
            <div className="rightBar">
            <h2>Packed</h2>
            {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              <h2>Consignments</h2>
              <div>
                {consList}
              </div>
            </div>
            <div className="btmBar">
              <div className="back_btn" onClick={this.setCourier.bind(this,false)}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );
      }
      else if (false && this.state.packable && this.state.boxSaved && this.state.consignments[this.state.current_con].courier && this.state.selectPackages){

         var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
         var boxList = this.state.boxes.map(( box, i ) => {
              var className = '';
              if(box.consignment !== undefined && box.consignment == this.state.current_con){
                className = 'current';
              }
              else if(box.consignment !== undefined){
                className = 'assigned';
              }
             return (
              <div className={"selectBox " + className} key={i} onClick={this.toggleBox.bind(this,i,this.state.current_con)}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });

        var completeDispatch = (<button className="completeDispatch" onClick={this.confirm}>Complete Dispatch</button>);

        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>
            <div>Select Packages XX</div>
            <h2>
            {this.state.packable.post_service.name}
            {boxList}
            </h2>
            {address_tag}
            </div>


            <div className="rightBar">
            <h2>Packed</h2>
              {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              <h2>Consignments</h2>
              <div>
                {consList}
              </div>
              {completeDispatch}
              {tracking_code}
              <div onClick={this.addConsignment}>
               Add Consignment
              </div>
            </div>
            <div className="btmBar">
              <div className="back_btn" onClick={this.setPackageSize.bind(this,false)}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );

      }
      else if (this.state.packable && this.state.boxSaved && this.state.consignments[this.state.current_con].courier){
        var service_classes = [];
        var currentPostService
         var weightList = this.state.boxes.map(( box, i ) => {
             return (
              <div key={i}>
              <div style={{padding:10}}>{box.weight}kg</div>
              </div>
             );
        });
        var selPack = this.state.packaging.map((p,i) => {
          return (<div className="packageItem">
             {p.name}
          </div>)
        });
        var consList = this.state.consignments.map(( con, i ) => {
             var currentClass = '';
             if( i === this.state.current_con ){
               currentClass = " current";
             }
             return (
              <div className={"cons_item " + currentClass} key={i} onClick={this.setConsignment.bind(this,i)}>
                  <i className="material-icons" onClick={this.removeConsignment.bind(this,i)}>close</i>
                  <div style={{padding:10}}>{i + 1} - {con.service.name}</div>
                  <div style={{padding:10}}>{con.packageSize.name}</div>
              </div>
             );
        });
        var tracking_code;
        this.props.root.state.utilities.post_services.forEach((sc) => {
          try{
            var sizes = JSON.parse(sc.package_sizes);
          }
          catch(e){
            var sizes = null;
          }

          try{
            var dest_list = JSON.parse(sc.destination_list);
          }
          catch(e){
            var dest_list = null;
          }


          if((dest_list == null) || (dest_list.accept && dest_list.accept.indexOf(this.state.packable.delivery_address.country_code) !== -1) || (dest_list.deny && dest_list.deny.indexOf(this.state.packable.delivery_address.country_code) == -1)){
            if( sizes !== null && (sizes.indexOf(parseInt(this.state.consignments[this.state.current_con].packageSize.id)) !== -1 || this.state.courier.id == sc.courier_id && sizes.indexOf(0) !== -1)){
              service_classes.push(sc);
            }
          }
        });
        var ss_added = [];
        var serviceSelect = service_classes.map(sc => {
          if(!ss_added.includes(sc.id)){
              ss_added.push(sc.id);
              var selected = "packScreenOpt";
              if(sc.id === this.state.consignments[this.state.current_con].service.id){
                selected += ' selected';
                if(parseInt(this.state.consignments[this.state.current_con].service.pre_tracked,10)){
                   tracking_code = (<div className="tracking_code_box"><input placeholder="Please Scan Tracking Code" id="tracking_code" /></div>);
                   this.focus = 'tracking_code';
                }
              }
              if(sc.service_class_id == this.state.packable.post_service_id){
                selected += ' recommended';
              }
              return (<div className={selected} onClick={this.setService.bind(this,sc)}>
                 {sc.name}
              </div>)
          }
        });
        var completeDispatch = (<button  className="completeDispatch" onClick={this.confirm} >Complete Dispatch</button>);
        var addConsignment
        if(this.state.consignments[this.state.current_con].service){
          addConsignment = (<div onClick={this.addConsignment} className="act_btn">Add Consignment</div>);
        }
        return (
          <div className="PackingStation" style={{padding:'10px'}}>
            <h1>PackingStation</h1>
            <div>
            <div>Service</div>
            <h2>
            {this.state.packable.post_service.name}
            </h2>
            <div className="serviceSelect">
            {serviceSelect}
            </div>
            {address_tag}
            {tracking_code}
            </div>
            <div className="rightBar">
            <h2>Packed</h2>
              {packedList}
              <h2>Boxes</h2>
              <div>
                {weightList}
              </div>
              <div className="packageItems">
              <h2>Packaging</h2>
              {selPack}
              </div>
              <h2>Consignments</h2>
              <div>
                {consList}
              </div>
              {addConsignment}
              {completeDispatch}

            </div>
            <div className="btmBar">
              <div className="back_btn" onClick={this.setPackageSize.bind(this,false)}><i className="fa fa-angle-left" /> Back</div>
            </div>
          </div>
        );
      }
      this.focus = 'searchPhrase';
      return (
        <div className="PackingStation noDisp">
          <h1>PackingStation</h1>
          <input onKeyPress={this.perCep} id="searchPhrase"/>
          <button className="find_dispatch" onClick={this.searchDispatch}>Submit</button>
        </div>
      );
    }
}

export default PackingStation;



// WEBPACK FOOTER //
// ./src/PackingStation.js